<template>
  <generic-modal
    size="large"
    :title="$t('fel guatemala configuration')"
    icon="receipt"
    image="/images/icons/fel_gt.jpg"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <generic-container
        icon="receipt"
        :show_plus="true"
        :title="$t('emitters')"
        :show_refresh="true"
        @refresh="init"
        class="ui basic segment"
        @add="add_billing"
      >
        <div class="ui two cards">
          <div class="card" v-for="(emitter, eidx) in emitters" :key="eidx">
            <div class="content">
              <img
                class="right floated mini ui image"
                src="/images/icons/enterprise_1.png"
              />
              <div class="header">{{ emitter.name }}</div>
              <div class="meta">{{ emitter.provider }}</div>
              <!-- <div class="description">
                Elliot requested permission to view your contact details
              </div> -->
            </div>
            <div class="extra content">
              <div class="ui two buttons">
                <div class="ui basic button" @click="edit(emitter)">
                  <i class="edit orange icon"></i> {{ $t("edit") }}
                </div>
                <div class="ui basic button" @click="remove(emitter)">
                  <i class="trash red icon"></i> {{ $t("delete") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{ emitters }}</pre> -->
      </generic-container>
    </div>
    <emitter-modal ref="emitter_modal" @created="init" />
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast } from "@/utils";
// import G4SBilling from "./G4SBilling";
// import MegaprintBilling from "./MegaprintBilling";
import EmitterModal from "./emitter_modal/Index";
// import { v4 } from "uuid";
// import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "FelGtConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    EmitterModal,
    // Wysywyg,
  },
  computed: {},
  data() {
    return {
      billing_templates: [],
      emitters: [],
    };
  },
  methods: {
    save(template) {
      let vm = this;
      local_api(vm, "post", "/fel_guatemala/emitter/do-save", {
        u: template.uuid,
        n: template.name,
        p: template.provider,
        d: template.set_as_default,
        s: template.setup,
        t: template.template,
      })
        .then(() => {
          vm.$emitt("saved");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    remove(emitter) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove fel emitter?"),
        function () {
          local_api(vm, "post", "/fel_guatemala/emitter/do-remove", {
            u: emitter.uuid,
          })
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit(emitter) {
      let vm = this;
      vm.$refs.emitter_modal.show_modal(emitter);
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      // let vm = this;
      return new Promise(function (resolve /* reject */) {
        resolve();
        // let settings = vm.settings;
        // local_api(vm, "post", "/fel_guatemala/do-save-configuration", {
        //   s: JSON.stringify({ billing_templates: vm.billing_templates }),
        // })
        //   .then(() => {
        //     resolve();
        //   })
        //   .catch((err) => {
        //     reject(err);
        //   });
        // Panfilo Baudilio
        // el lic urizar
      });
    },
    add_billing() {
      let vm = this;
      vm.$refs.emitter_modal.show_modal();
    },
    provider_component(/* template */) {
      return undefined;
      // if (template.provider == "g4s") return G4SBilling;
      // else if (template.provider == "megaprint") return MegaprintBilling;
      // else return undefined;
    },
    // prov_setup_updated(index, setup) {
    //   this.billing_templates[index].setup = setup;
    // },
    init() {
      let vm = this;
      local_api(vm, "post", "/fel_guatemala/emitter/do-get-all")
        .then((emitters) => {
          vm.emitters = emitters;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    this.init();
    // local_api(this, "post", "/fel_guatemala/do-get-configuration")
    //   .then((conf) => {
    //     if (conf) {
    //       let setup = JSON.parse(conf.setup);
    //       vm.billing_templates = setup.billing_templates;
    //     }
    //   })
    //   .catch((err) => {
    //     vm.$alertify.error(stringify(err));
    //   });
  },
  watch: {
    // billing_templates() {
    //   let vm = this;
    //   setTimeout(() => {
    //     window.jQuery(vm.$refs.tabs_billing).find(".item").tab();
    //     window.jQuery(vm.$refs.provider).dropdown({
    //       onChange(value, text, $element) {
    //         let idx = $element.data("idx");
    //         if (idx != undefined) vm.billing_templates[idx].provider = value;
    //       },
    //     });
    //     window.jQuery(vm.$refs.set_as_default_checkbox).checkbox({
    //       onChecked() {
    //         let trgtIndex = window
    //           .jQuery(this)
    //           .closest(".checkbox")
    //           .data("idx");
    //         vm.billing_templates.map((b) => {
    //           b.set_as_default = false;
    //         });
    //         vm.billing_templates[trgtIndex].set_as_default = true;
    //       },
    //     });
    //     window.jQuery(".ui.tabular.menu .item").tab();
    //   }, 500);
    // },
  },
  updated: function () {},
};
</script>
